import { useState } from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react';
import ChevronLeftIcon from '../../../assets/icons/chevron-left.svg?react';
dayjs.extend(timezone);
dayjs.extend(utc);


const SystemLogListItem = ({ log }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const logLevelColor = (logLevel) => {
    switch (logLevel) {
      case 'INFO': return 'info';
      case 'WARNING': return 'warning';
      case 'ERROR': return 'error';
      case 'CRITICAL': return 'critical';
      default: return 'unknown';
    }
  }

  return (
    <>
      <tr key={log.LogNumber}>
        <td>
          <button
            className="expand-button"
            onClick={() => setIsExpanded(!isExpanded)}
            aria-label={isExpanded ? '접기' : '펼치기'}
          >
            <ChevronDownIcon style={{ transform: isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }} />
          </button>
        </td>
        <td>{log.EventAt ? dayjs(log.EventAt).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
        <td>
          <span className={`status-badge ${logLevelColor(log.LogLevel)}`}>
            {log.LogLevel || '-'}
          </span>
        </td>
        <td>{log.Message || '-'}</td>
        <td>{log.ServiceName || '-'}</td>
        <td>{log.ErrorCode || '-'}</td>
        <td>{log.UserEmail || '-'}</td>
      </tr>
      {isExpanded && (
        <tr className="system-log-table-row-expanded">
          <td colSpan="7" className="bg-gray-200">
            <div className="flex flex-col gap-4">
              <p className="text-b2-700 text-gray-400">로그 상세</p>
              <div className="detail-section">
                <div className="log-details">
                  <pre>{JSON.stringify(log, null, 2)}</pre>
                </div>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  )
}

export default SystemLogListItem